import React from 'react';
import { X, Trash2, Plus, Minus } from 'lucide-react';
import '../styles/Cart.css';

const Cart = ({ isOpen, onClose, cart, onUpdateQuantity, onRemoveItem, cartTotal }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={onClose}></div>
      <div className={`cart-drawer ${isOpen ? 'cart-drawer-open' : ''}`}>
        <div className="cart-header">
          <h2 className="heading-2">Koszyk</h2>
          <button className="cart-close" onClick={onClose} aria-label="Zamknij koszyk">
            <X size={24} />
          </button>
        </div>

        <div className="cart-content">
          {cart.length === 0 ? (
            <div className="cart-empty">
              <p className="body-regular">Twój koszyk jest pusty</p>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cart.map(item => (
                  <div key={item.id} className="cart-item">
                    <img src={item.image} alt={item.name} className="cart-item-image" />
                    <div className="cart-item-details">
                      <h3 className="body-regular">{item.name}</h3>
                      <p className="body-small">{item.price.toFixed(2)} zł</p>
                      <div className="cart-item-quantity">
                        <button 
                          onClick={() => onUpdateQuantity(item.id, Math.max(1, item.quantity - 1))}
                          aria-label="Zmniejsz ilość"
                        >
                          <Minus size={16} />
                        </button>
                        <span>{item.quantity}</span>
                        <button 
                          onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                          aria-label="Zwiększ ilość"
                        >
                          <Plus size={16} />
                        </button>
                      </div>
                    </div>
                    <button 
                      className="cart-item-remove"
                      onClick={() => onRemoveItem(item.id)}
                      aria-label="Usuń produkt"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="cart-footer">
                <div className="cart-total">
                  <span className="body-large">Razem:</span>
                  <span className="heading-2">{cartTotal.toFixed(2)} zł</span>
                </div>
                <button className="btn-primary cart-checkout">
                  Przejdź do kasy
                </button>
                <p className="body-small" style={{ textAlign: 'center', marginTop: '16px', color: 'var(--text-tertiary)' }}>
                  * To jest demo - funkcja płatności nie jest aktywna
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Cart;
